import React from "react";
import AllDonations from "../Donation/AllDonations";

const AllExpenses = () => {
  return <AllDonations collection={"expense"} />;
};

export default AllExpenses;
